import { useField } from '@formily/vue'
import { observer } from '@formily/reactive-vue'
import { h, defineComponent } from 'vue-demi'
import './style.scss'
import Layout from './layout.vue'

const UploadPreviewCard = observer(
  defineComponent({
    name: 'UploadPreviewCard',
    setup (props, { attrs }) {
      const fieldRef = useField()
      const field = fieldRef.value

      return () => {
        const values = field.value || []
        return h(
          Layout,
          {
            props: {
              ...props,
              values
            },
            attrs: {...attrs}
          },
          []
        )
      }
    }
  })
)

export default UploadPreviewCard
